import CtaTool from '@/atoms/CtaTool';
import { CTAToolType } from '@/atoms/CtaTool/type';
import clx from 'classnames';

type CTAToolsProps = {
  items: CTAToolType[];
  className?: string;
};
const CTATools = ({ items, className }: CTAToolsProps) => (
  <ul
    className={clx(
      'flex gap-2 flex-nowrap overflow-x-auto md:overflow-x-hidden hover:overflow-x-auto max-w-full h-fit',
      className,
    )}
  >
    {items.map((item) => (
      <li key={item.key} className="shrink-0">
        <CtaTool {...item} />
      </li>
    ))}
  </ul>
);

export default CTATools;
export type { CTAToolType };
